import PropTypes from 'prop-types'

export function GenderField({ name, onChange, label, value, additionalClass, isError, disabled }) {
  return (
    <div
      className={`field field-gender ${additionalClass || ''} ${
        disabled && 'field--disabled'
      } ${isError && 'is-danger'}`}
    >
      {label && (
        <label htmlFor={name} className="label">
          {label}
        </label>
      )}
      <div>
        <input
          type="radio"
          name={name}
          id="male"
          value="Male"
          onChange={!disabled ? onChange : undefined}
          checked={value === 'Male'}
        />
        <label htmlFor="male">Male</label>
      </div>
      <div>
        <input
          type="radio"
          name={name}
          id="female"
          value="Female"
          onChange={!disabled ? onChange : undefined}
          checked={value === 'Female'}
        />
        <label htmlFor="female">Female</label>
      </div>
    </div>
  )
}

GenderField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default GenderField
